const TEMPLATE_NAME = 'REPORT_PDF_VISIT_DETAIL';

// const sort = function (a, b) {
//   if (a.end && b.end) {
//     return new Date(b.end) - new Date(a.end);
//   } else if (a.end && b.dateDone) {
//     return new Date(b.dateDone) - new Date(a.end);
//   } else if (a.dateDone && b.end) {
//     return new Date(b.end) - new Date(a.dateDone);
//   } else if (a.dateDone && b.dateDone) {
//     return new Date(b.dateDone) - new Date(a.dateDone);
//   }
// };

const initialState = () => ({
  loading: false,
  data: [],
  professional: false,
  // nurse: false,
  activeIndex: 0,
  filter: {
    term: '',
    data: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const data = action.payload;
      return {
        ...state,
        loading: false,
        professional: true,
        // nurse: false,
        data: data,
        filter: {
          ...state.filter,
          data: (data, state.filter.term)
        }
      };
    }
    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }
    default:
      return state;
  }
};
export default reducer;
